/* Structural positioning only — colors/spacing inside the child come from
   Astryx design tokens (resolved inside its own <Theme> scope). */

.corner {
  position: fixed;
  right: var(--spacing-6);
  bottom: var(--spacing-6);
  z-index: 500;
}
